
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rental-listings/city/[...slug]",
      function () {
        return require("private-next-pages/rental-listings/city/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rental-listings/city/[...slug]"])
      });
    }
  